"use client"

import { Skeleton } from "antd"

const SelectPeopleSkeleton = () => {
  
  return (
    <Skeleton.Button
      style={{ marginTop: 15 }}
      block
      size='large'
      active
    />
  )
}

export default SelectPeopleSkeleton